import React, { useState, useEffect } from "react";
import { CartGridProduct } from "../CartGridProduct";
import useCartData from "@arctheme-hooks/useCartData";

export const GridLayout = ({ settings, cartData }: {settings: any, cartData: ICart}) => {
  const { section, routes } = settings;
  const {cart, fetchCart}: any = useCartData();
  const [cartItems, setCartItems]: any = useState([]);
  const productLayout = section.product_layout;
  const useSubscriptions = false;
  const showTitles = false;

  useEffect(() => {
    if (fetchCart) {
      fetchCart();
    }
  }, []);

  useEffect(() => {
    if (cart?.items && cart.items !== cartItems) {
      setCartItems(cart.items);
    }
  }, [cart, cartItems]);

  const subscriptionProducts = React.useMemo(
    () => cartItems.filter((item) => item.selling_plan_allocation),
    [cartItems]
  );
  
  const oneTimeProducts = React.useMemo(
    () => cartItems.filter((item) => !item.selling_plan_allocation),
    [cartItems]
  );

  return (
    <div className={`flex flex-col gap-4 lg:gap-y-[48px]`}>
      {oneTimeProducts?.length > 0 && (
        <div className="flex-col flex gap-2 lg:gap-6">
          {showTitles && <p className={`text-sm lg:text-2xl font-medium`}>One time purchase</p>}
          <div className={`grid grid-cols-1 lg:grid-cols-2 gap-2 lg:gap-6`}>
            {oneTimeProducts?.map((item, index) => (
              <React.Fragment key={index}>
                <CartGridProduct item={item} settings={settings} />
              </React.Fragment>
            ))}
          </div>
        </div>
      )}
      {subscriptionProducts.length > 0 && (
        <div className="flex-col flex gap-2 lg:gap-6">
          {showTitles &&  <p className={`text-sm lg:text-2xl font-medium`}>Subscription products</p>}
          <div className={`grid grid-cols-1 lg:grid-cols-2 gap-2 lg:gap-6`}>
            {subscriptionProducts.map((item, index) => (
              <React.Fragment key={index}>
                <CartGridProduct item={item} settings={settings} />
              </React.Fragment>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};
